import QRCode from 'qrcode'

const apiAesKey = '1B289FC0225F906E'
// 金额或者数字格式化
export function formatMoney(s) { return _formatMoney(s) }
// 格式化时间
export function dateFormat(date) { return _formatDate(date) }
// 格式化日期（无时分秒）
export function dateFormat2(date) { return _formatDate2(date) }
// 格式化日期（无天时分秒）
export function dateFormat3(date) { return _formatDate3(date) }
// 时间戳格式化
export function timestampFormat(date, fmt) { return _timestampFormat(date, fmt) }
// 设置cookie
export function setCookie(key, value, t) { return _setCookie(key, value, t) }
// 获取cookie
export function getCookie(key) { return _getCookie(key) }
// 删除cookie
export function removeCookie(key) { return _removeCookie(key) }
// 获取查询参数
export function getQueryParams() { return _getQueryParams() }
// 格式化object转后台list（内容管理）
export function formatCheckList(data) { return _formatCheckList(data) }
// 格式化fileInfo（内容管理）
export function formatFileInfo(data) { return _formatFileInfo(data) }
// 数字四舍五入
export function numberRound(num, length) { return _numberRound(num, length) }
// 计算文件B/KB/M/G
export function computeFileSize(size) { return _computeFileSize(size) }
// url转二维码转base64
export function urlToQRCode(url) { return _urlToQRCode(url) }
// url转二维码转base64（含logo）
export function promiseUrlToQRCode(url, logoUrl) { return _promiseUrlToQRCode(url, logoUrl) }
// 将base64转换为文件
export function data64toFile(dataurl, filename) { return _data64toFile(dataurl, filename) }
// 将base64转换为文件
export function downloadImage(imgsrc, name) { return _downloadImage(imgsrc, name) }
// 递归删除某个属性
export function recursionDelete(obj, name) { return _recursionDelete(obj, name) }
// AES 加密数据
export function encryption(data, keystr) { return _encryption(data, keystr) }
// AES 解密数据
export function decode(data, keystr) { return _decode(data, keystr) }
// des加密
export function encryptByDES(data, keystr) { return _encryptByDES(data, keystr) }
// des 解密数据
export function decryptByDES(data, keystr) { return _decryptByDES(data, keystr) }
// 递归获取某个字段值
export function recursionGetField(arr, traverseField, valueField, flag, getField) { return _recursionGetField(arr, traverseField, valueField, flag, getField) }
// 财务分析处理数据
export function processingData(item) { return _processingData(item) }
// 财务分析获取平均线
export function getAverageLine(item) { return _getAverageLine(item) }
// 数字增加千位分隔符
export function numFormat(num, keepDecimalsNum) { return _numFormat(num, keepDecimalsNum) }
// 数字去除千位分隔符
export function numReplaceFormat(num) { return _numReplaceFormat(num) }
// 深拷贝
export function deepClone(sourceObj) { return _deepClone(sourceObj) }

// 表格默认每页条数
export function getTableDefaultPageSize() { return _getTableDefaultPageSize() }

// 金额或者数字格式化
function _formatMoney(s) {
    if (/[^0-9\.]/.test(s)) return "invalid value";
    s = s.replace(/^(\d*)$/, "$1.");
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s))
        s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    return s.replace(/^\./, "0.")
}

// function _formatMoney(s, n) {
//     /*
//      * 参数说明：
//      * s：要格式化的数字
//      * n：保留几位小数
//      * */
//     n = n > 0 && n <= 20 ? n : 2;
//     s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
//     var l = s.split(".")[0].split("").reverse(),
//       r = s.split(".")[1];
//      var t = "";
//     for (let i = 0; i < l.length; i++) {
//       t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
//     }
//     return t.split("").reverse().join("") + "." + r;
//   }
function _formatDate(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()

    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds

    var str = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    return str
}

// 格式化日期（无时分秒）
function _formatDate2(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day

    var str = year + '-' + month + '-' + day
    return str
}
// 格式化日期（无天时分秒）
function _formatDate3(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    month = month < 10 ? '0' + month : month

    var str = year + '-' + month
    return str
}
function _setCookie(key, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = key + '=' + value
        + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
        + ';path=/'
        + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
}
function _getCookie(key) {
    // let name = key + "=";
    let ca = document.cookie.split(';');
    let item = {}
    ca.forEach(obj => {
        let keyname = obj.substring(0, obj.indexOf('=')).replace(/ /g, '')
        item[keyname] = obj.substring(obj.indexOf('=') + 1) ? obj.substring(obj.indexOf('=') + 1) : ''
    })
    return item[key]
}
function _removeCookie(key) {
    setCookie(key, '', -365)
}
function _getQueryParams() {
    var url = location.search // 获取url中"?"符后的字串
    // console.log("url---", location);
    var theRequest = {}
    if (url.indexOf('?') !== -1) {
        var strs = url.substr(1)
        strs = strs.split('&')
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
    }
    return theRequest
}
function _formatCheckList(data) {
    let tmpList = []
    for (let i in data) {
        if (data[i].status) {
            delete data[i].status
            tmpList.push(data[i])
        }
    }
    return tmpList
}
function _numberRound(num, length) {
    let len = length
    if (isNaN(num)) {
        return '不是数字'
    } else {
        const p1 = Math.pow(10, len + 1)
        const p2 = Math.pow(10, len)
        let number = (Math.round(num * p1 / 10) / p2).toFixed(len)
        return number
    }
}
function _urlToQRCode(url) {
    let base64 = ''
    let canvas = document.createElement('canvas')
    QRCode.toCanvas(canvas, url, { margin: 0 }, (error) => {
        if (error) {
            base64 = url
        } else {
            base64 = canvas.toDataURL('image/png')
        }
    })
    return base64
}
function _promiseUrlToQRCode(url, logoUrl) {
    let image = new Image()
    image.setAttribute('crossOrigin', 'Anonymous') // 防止画图污染
    image.src = logoUrl
    let qrcode = new Promise(function (resolve) {
        image.onload = function () {
            let base64 = ''
            let canvas = document.createElement('canvas')
            canvas.width = 160
            canvas.height = 160
            let ctx = canvas.getContext('2d')
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, 160, 160)
            QRCode.toCanvas(canvas, url, (error) => {
                if (error) {
                    base64 = url
                } else {
                    base64 = canvas.toDataURL('image/png')
                }
            })
            ctx.fillStyle = '#fff' // logo padding颜色
            ctx.fillRect(75, 75, 30, 30) // logo 位置 大小
            ctx.drawImage(image, 80, 80, 20, 20) // logo
            ctx.restore()
            base64 = canvas.toDataURL('image/png')
            resolve(base64)
        }
    })
    return qrcode
}
function _data64toFile(dataurl, filename) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
}
function _formatFileInfo(data) {
    let tmp = ''
    if (data.type === 'add') {
        delete data.type
        tmp = JSON.stringify(data)
    }
    return tmp
}
function _timestampFormat(date, fmt) {
    let time = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in time) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (time[k]) : (('00' + time[k]).substr(('' + time[k]).length)))
        }
    }
    return fmt
}
function _computeFileSize(size) {
    let tmp = 0
    if (size < 1024) {
        tmp = _numberRound(size, 2) + 'B'
    } else if (size < 1024 * 1024) {
        tmp = _numberRound(size / 1024, 2) + 'KB'
    } else if (size < 1024 * 1024 * 1024) {
        tmp = _numberRound(size / 1024 / 1024, 2) + 'M'
    } else {
        tmp = _numberRound(size / 1024 / 1024 / 1024, 2) + 'G'
    }
    return tmp
}
function _downloadImage(imgsrc, name) { // 下载图片地址和图片名
    let image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function () {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
    }
    image.src = imgsrc
}
// 递归删除数组中的某个属性
function _recursionDelete(obj, name) {
    if (!obj[name].length) {
        delete obj[name]
    } else {
        obj[name].forEach((item) => {
            if (!item[name].length) {
                delete item[name]
            } else {
                _recursionDelete(item, name)
            }
        })
    }
}
// 递归获取某个字段值 flag:数组(valueField的值数组) arr:数组(最外层数组) getField:字符串(要获取的值的字段名) valueField:字符串(通过这个字段的值来判断) traverseField:字符串(要遍历的字段)
function _recursionGetField(arr, traverseField, valueField, flag, getField) {
    let getFieldArr = []
    getFieldMethod(arr, traverseField, valueField, flag, getField)
    function getFieldMethod(arr, traverseField, valueField, flag, getField) {
        arr.some(item => {
            if (item[valueField] === flag[getFieldArr.length]) {
                getFieldArr.push(item[getField])
                if (getFieldArr.length < flag.length && item[traverseField]) {
                    getFieldMethod(item[traverseField], traverseField, valueField, flag, getField)
                }
                return true
            }
        })
    }
    return getFieldArr
}
// 财务分析
function _processingData(item) {
    let flag = false // 用来区别是否有值不为--
    let type = 0 // 用来区别值的正负 1都为正数 2都为负数 3有正有负
    item.fndata.some(item => {
        if (item) {
            flag = true
            return true
        }
    })
    // 区别是否有有值的
    if (!flag) {
        item.fndata.forEach(() => {
            item.rect.push({
                height: 1,
                color: '#2475F4',
                y: 19
            })
        })
    } else {
        let positive = false
        let minus = false
        item.fndata.forEach(item => {
            if (item) {
                if (Number(item.split('%')[0]) >= 0) {
                    positive = true
                } else if (Number(item.split('%')[0]) < 0) {
                    minus = true
                }
            }
        })
        if (positive && minus) {
            type = 3
        } else if (minus) {
            type = 2
        } else if (positive) {
            type = 1
        }
        if (type === 1) { // 都为正数
            let maxValue = ''
            // 找出最大值
            item.fndata.forEach(option => {
                if (!maxValue && option) {
                    maxValue = Number(option.split('%')[0])
                }
                if (option) {
                    if (Number(option.split('%')[0]) > maxValue) {
                        maxValue = Number(option.split('%')[0])
                    }
                }
            })
            // 分配高度
            item.fndata.forEach((option, index) => {
                if (option) {
                    if (index === item.fndata.length - 1) {
                        if (maxValue === Number(option.split('%')[0])) {
                            if (Number(option.split('%')[0]) === Number(item.fndata[index - 1].split('%')) && Number(option.split('%')[0]) === 0) {
                                item.rect.push({
                                    height: 1,
                                    color: '#2475F4',
                                    y: 19
                                })
                            } else {
                                if (Number(item.fndata[index - 1].split('%'))) {
                                    item.rect.push({
                                        height: 20,
                                        color: Number(option.split('%')[0]) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                        y: 0
                                    })
                                } else {
                                    item.rect.push({
                                        height: 20,
                                        color: '#FCB831',
                                        y: 0
                                    })
                                }
                            }
                        } else {
                            let height = 1
                            height = option.split('%')[0] / maxValue * 20
                            item.rect.push({
                                height: height ? height : 1,
                                color: Number(option.split('%')[0]) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                y: 20 - (height ? height : 1)
                            })
                        }
                    } else {
                        if (maxValue === Number(option.split('%')[0])) {
                            if (Number(option.split('%')[0]) === 0) {
                                item.rect.push({
                                    height: 1,
                                    color: '#2475F4',
                                    y: 19
                                })
                            } else {
                                item.rect.push({
                                    height: 20,
                                    color: '#2475F4',
                                    y: 0
                                })
                            }
                        } else {
                            let height = 0
                            height = option.split('%')[0] / maxValue * 20
                            item.rect.push({
                                height: height ? height : 1,
                                color: '#2475F4',
                                y: 20 - (height ? height : 1)
                            })
                        }
                    }
                } else {
                    item.rect.push({
                        height: 1,
                        color: '#2475F4',
                        y: 19
                    })
                }
            })
        } else if (type === 2) { // 都为负数
            let minValue = ''
            // 找出最小值
            item.fndata.forEach(option => {
                if (!minValue && option) {
                    minValue = Number(option.split('%')[0])
                } else {
                    if (Number(option.split('%')[0]) < minValue) {
                        minValue = Number(option.split('%')[0])
                    }
                }
            })
            // 分配高度
            item.fndata.forEach((option, index) => {
                if (option) {
                    if (index === item.fndata.length - 1) {
                        if (minValue === option.split('%')[0]) {
                            item.rect.push({
                                height: 20,
                                color: Number(option.split('%')[0]) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                y: 0
                            })
                        } else {
                            let height = 1
                            height = option.split('%')[0] / minValue * 20
                            item.rect.push({
                                height: height ? height : 1,
                                color: Number(option.split('%')[0]) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                y: 0
                            })
                        }
                    } else {
                        if (minValue === option.split('%')[0]) {
                            item.rect.push({
                                height: 20,
                                color: '#2475F4',
                                y: 0
                            })
                        } else {
                            let height = 0
                            height = option.split('%')[0] / minValue * 20
                            item.rect.push({
                                height: height ? height : 1,
                                color: '#2475F4',
                                y: 0
                            })
                        }
                    }
                } else {
                    item.rect.push({
                        height: 1,
                        color: '#2475F4',
                        y: 0
                    })
                }
            })
        } else if (type === 3) { // 有正有负
            let maxValue = ''
            let minValue = ''
            let medianValue = '' // 中间值 作为负值的起点值
            // 找出最大值和最小值
            item.fndata.forEach(option => {
                // 找最大值
                if (!maxValue && option && Number(option.split('%')[0]) >= 0) {
                    maxValue = Number(option.split('%')[0])
                } else {
                    if (Number(option.split('%')[0]) > maxValue) {
                        maxValue = Number(option.split('%')[0])
                    }
                }
                // 找最小值
                if (!minValue && option && Number(option.split('%')[0]) < 0) {
                    minValue = Number(option.split('%')[0])
                } else {
                    if (Number(option.split('%')[0]) < Number(minValue)) {
                        minValue = Number(option.split('%')[0])
                    }
                }
            })
            maxValue = maxValue ? maxValue : 1
            medianValue = maxValue / (maxValue + Math.abs(minValue)) * 20
            medianValue = Math.ceil(medianValue)
            minValue = Math.floor(minValue)
            // 分配高度
            item.fndata.forEach((option, index) => {
                if (option) {
                    if (index === item.fndata.length - 1) {
                        if (Number(option.split('%')[0]) >= 0) {
                            if (maxValue === Number(option.split('%')[0])) {
                                item.rect.push({
                                    height: medianValue,
                                    color: Number(option.split('%')) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                    y: 0
                                })
                            } else {
                                let height = 1
                                height = option.split('%')[0] / maxValue * medianValue
                                item.rect.push({
                                    height: height ? height : 1,
                                    color: Number(option.split('%')) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                    y: medianValue - (height ? height : 1)
                                })
                            }
                        } else {
                            if (minValue === Number(option.split('%')[0])) {
                                item.rect.push({
                                    height: 20 - medianValue,
                                    color: Number(option.split('%')) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                    y: medianValue
                                })
                            } else {
                                let height = 1
                                height = option.split('%')[0] / minValue * (20 - medianValue)
                                item.rect.push({
                                    height: height ? height : 1,
                                    color: Number(option.split('%')) > Number(item.fndata[index - 1].split('%')) ? '#FCB831' : '#FF6969',
                                    y: medianValue
                                })
                            }
                        }
                    } else {
                        if (Number(option.split('%')[0]) >= 0) {
                            let height = 1
                            height = option.split('%')[0] / maxValue * medianValue
                            item.rect.push({
                                height: height ? height : 1,
                                color: '#2475F4',
                                y: medianValue - (height ? height : 1)
                            })
                        } else {
                            let height = 1
                            height = option.split('%')[0] / minValue * (20 - medianValue)
                            item.rect.push({
                                height: height ? height : 1,
                                color: '#2475F4',
                                y: medianValue
                            })
                        }
                    }
                } else {
                    item.rect.push({
                        height: 1,
                        color: '#2475F4',
                        y: medianValue - 1
                    })
                }
            })
        }
    }
}
// 财务分析获取平均线
function _getAverageLine(item) {
    let height = 0
    let average = 20
    item.rect.forEach(item => {
        height += item.height
    })
    if (height) {
        average = height / item.rect.length
    }
    item.average = 20 - average
}
// 数字增加千位分隔符
function _numFormat(num, keepDecimalsNum) {
    if (isNaN(num)) {
        return num
    }
    let minus = false
    if (keepDecimalsNum && keepDecimalsNum > 0) {
        num = Number(num).toFixed(keepDecimalsNum)
    }
    num = num + ''
    if (num.indexOf('-') !== -1) {
        minus = true
        num = num.slice(1)
    }
    num = num.toString().split('.') // 分隔小数点
    var arr = num[0].split('').reverse() // 转换成字符数组并且倒序排列
    var res = []
    for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
            res.push(',')// 添加分隔符
        }
        res.push(arr[i])
    }
    res.reverse()// 再次倒序成为正确的顺序
    if (num[1]) { // 如果有小数的话添加小数部分
        res = res.join('').concat('.' + num[1])
    } else {
        res = res.join('')
    }
    if (minus) {
        res = '-' + res
    }
    return res
}
// 去除千位符
function _numReplaceFormat(num) {
    if (num !== undefined) {
        num = num.toString()
        num = num.replace(/[ ]/g, '') // 去除空格
        num = num.replace(/,/gi, '')
        return Number(num)
    }
}
// 深拷贝
function _deepClone(sourceObj) {
    if (typeof sourceObj !== 'object') {
        return sourceObj
    }
    return JSON.parse(JSON.stringify(sourceObj))
}

//表格默认每页条数
function _getTableDefaultPageSize() {
    return 20
}